const BASE_URL = 'https://api.happer.fr/api/';

const APIS = {
    // Auth
    CHECK_USERNAME: BASE_URL + 'v1/user/auth/check-username-availability',
    SIGNUP: BASE_URL + 'v1/user/auth/signup',
    SIGNUP_VERIFY_OTP: BASE_URL + 'v1/user/auth/signup/verify-otp',
    SIGNUP_RESEND_OTP: BASE_URL + 'v1/user/auth/signup/resend-otp',
    LOGIN: BASE_URL + 'v1/user/auth/login',
    GOOGLE_LOGIN: BASE_URL + 'v1/user/auth/google-login',
    APPLE_LOGIN: BASE_URL + 'v1/user/auth/apple-login',
    GUEST_LOGIN: BASE_URL + 'v1/user/auth/guest-login',
    AUTH_ME: BASE_URL + 'v1/user/auth/me',
    LOGOUT: BASE_URL + 'v1/user/auth/logout',
    REGISTER_DEVICE: BASE_URL + 'v1/user/auth/register-device',
    FORGOT_PASSWORD: BASE_URL + 'v1/user/auth/forgot-password',
    FORGOT_PASSWORD_VERIFY_OTP: BASE_URL + 'v1/user/auth/forgot-password/verify-otp',
    RESET_PASSWORD: BASE_URL + 'v1/user/auth/reset-password',

    // Address
    ADD_ADDRESS: BASE_URL + 'v1/user/address/add-address',
    GET_ALL_ADDRESSES: BASE_URL + 'v1/user/address/get-all-addresses',
    GET_ADDRESS: BASE_URL + 'v1/user/address/get-address/',
    EDIT_ADDRESS: BASE_URL + 'v1/user/address/edit-address/',
    DELETE_ADDRESS: BASE_URL + 'v1/user/address/delete-address/',

    // Products
    GET_LINKED_PRODUCTS: BASE_URL + 'v1/user/products/get-linked-products',
    GET_PRODUCTS_LIST: BASE_URL + 'v1/user/products/get-products-list',
    GET_PRODUCT: BASE_URL + 'v1/user/products/get-product/',
    GET_LIKED_PRODUCTS: BASE_URL + 'v1/user/products/get-liked-products',
    LIKE_PRODUCT: BASE_URL + 'v1/user/products/',
    UNLIKE_PRODUCT: BASE_URL + 'v1/user/products/',

    // Followers
    FOLLOW_USER: BASE_URL + 'v1/user/followers/follow',
    UNFOLLOW_USER: BASE_URL + 'v1/user/followers/unfollow',

    // Selfies
    SUBMIT_SELFIE: BASE_URL + 'v1/user/selfies/submit-selfie',
    GET_OWN_SELFIES: BASE_URL + 'v1/user/selfies/get-own-selfies',
    GET_NORMAL_USER_SELFIES: BASE_URL + 'v1/user/selfies/get-normal-user-selfies',
    GET_CREATOR_SELFIES: BASE_URL + 'v1/user/selfies/get-creator-selfies',
    GET_SELFIE_SUGGESTIONS: BASE_URL + 'v1/user/selfies/get-suggestions',
    GET_LIKED_SELFIES: BASE_URL + 'v1/user/selfies/get-liked-selfies',
    GET_SELFIE: BASE_URL + 'v1/user/selfies/get-selfie/',
    LIKE_SELFIE: BASE_URL + 'v1/user/selfies/',
    UNLIKE_SELFIE: BASE_URL + 'v1/user/selfies/',

    // Common
    FILE_UPLOAD: BASE_URL + 'v1/common/file-upload',

    // Profile
    UPDATE_PROFILE_IMAGE: BASE_URL + 'v1/user/profile/update-profile-image',
    EDIT_PROFILE: BASE_URL + 'v1/user/profile/edit-profile',
    COMPLETE_ESIGN: BASE_URL + 'v1/user/profile/complete-esign',
    USER_PROFILE_STATS: BASE_URL + 'v1/user/profile/user-profile-stats/',
    USER_SELFIES: BASE_URL + 'v1/user/profile/user-selfies/',

    // Carts
    ADD_TO_CART: BASE_URL + 'v1/user/carts/add-to-cart',
    GET_MY_CART: BASE_URL + 'v1/user/carts/get-my-cart',
    GET_CART_STATS: BASE_URL + 'v1/user/carts/get-cart-stats',
    REMOVE_CART_ITEM: BASE_URL + 'v1/user/carts/remove-cart-item/',
    INITIATE_PAYMENT: BASE_URL + 'v1/user/carts/initiate-payment',
    GET_PURCHASED_PRODUCTS: BASE_URL + 'v1/user/carts/get-purchased-products',

    // Legacy / other (not yet migrated)
    CHANGE_PASSWORD_API: BASE_URL + 'users/modify_password',
    PROFILE_WISH_LIST_API: BASE_URL + 'wishes/me',
    PRODUCT_WIN_API: BASE_URL + 'products/win',
    MODIFY_PASSWORD: BASE_URL + 'users/modify_password',
    GET_WIN_DATA: BASE_URL + 'products/win',
    GET_NOTIFICATION: BASE_URL + 'notifications/user',
};

export {
    APIS, BASE_URL
};
